export enum SOCIAL_NAME {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  APPLE = 'apple',
}

export enum CONNECT_METHOD {
  PASSWORD = 'password',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  APPLE = 'apple',
  NATIVE = 'native',
}
